import {
  linksItems,
  contactItems,
  socialItems,
  defaultAdress,
} from "./dataContent"

import "./Footer.scss"

interface IFooterProps {
  /** Conteúdo da primeira coluna */
  linksInfos?: { text: string; link: string }[]
  links?: {}[]
  /** Conteúdo da segunda coluna */
  contactInfos?: { title: string; tel: string }[]
  /** Conteúdo da terceira coluna */
  socialInfos?: { icon: string; link: string; alt: string }[]
  /** Texto com copyright */
  copyrightText?: string
  /** Texto com endereço */
  address?: string
}

const Footer = ({
  links,
  linksInfos = linksItems(links),
  contactInfos = contactItems,
  socialInfos = socialItems,
  copyrightText = defaultAdress.copy,
  address = defaultAdress.address,
}: IFooterProps) => {
  const getDomain = (link) => {
    return link.replace(/.+\/\/|www.|\..+/g, "")
  }

  return (
    <footer className="ds-footer">
      <div className="ds-footer__container-grid">
        <div className="ds-footer-links">
          <ul className="ds-footer-links__list">
            {linksInfos.map(({ text, link }, index) => (
              <li
                className="ds-footer-links__listitem"
                key={`link-info-${index}`}
              >
                <a
                  className="ds-footer-links__link"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={link}
                >
                  {text}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <>
          <div className="ds-footer-social-medias">
            <h4 className="ds-footer-social-medias__title">acompanhe</h4>
            <ul className="ds-footer-social-medias__list">
              {socialInfos.map(({ icon, link, alt }, index) => (
                <li
                  className="ds-footer-social-medias__listitem"
                  key={`link-${index}`}
                >
                  <a
                    className="ds-footer-social-medias__socialmedia"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={link}
                    aria-label={`${getDomain(link)}, ${alt}`}
                    role="button"
                  >
                    <div dangerouslySetInnerHTML={{ __html: icon }} />
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="ds-footer-contact-infos">
            <ul className="ds-footer-contact-infos__list">
              {contactInfos.map(({ title, tel }, index) => (
                <li
                  className="ds-footer-contact-infos__listitem"
                  key={`contact-info-${index}`}
                  aria-label={title}
                >
                  <p className="ds-footer-contact-infos__title">{title}</p>
                  <p className="ds-footer-contact-infos__telephone" dangerouslySetInnerHTML={{ __html: tel }} />
                </li>
              ))}
            </ul>
          </div>
        </>
      </div>
      <div className="ds-footer-legal-info">
        <address>
          <p className="ds-footer-legal-info__copyright">{copyrightText}</p>
          <p className="ds-footer-legal-info__postal"> {address} </p>
        </address>
      </div>
    </footer>
  )
}

export default Footer
